
const fat = {
	path: '/fat',
	component: ()=>import("@/views/main.vue"),
	meta:{
		title:"供应商管理后台",
		requiresAuth:false
	},
	children:[
		{
			path: 'Home',
			title:"首页",
			component: ()=>import("@/views/fat/Home.vue"),
			meta:{
				title:"首页",
				requiresAuth:false
			},
		},
		{
			path: 'ShopSize',
			component: ()=>import("@/views/fat/ShopSize.vue"),
			meta:{
				title:"商品规格",
				requiresAuth:false
			},
		},
		{
			path: 'Brand',
			component: ()=>import("@/views/fat/Brand.vue"),
			meta:{
				title:"品牌管理",
				requiresAuth:false
			},
		},
		{
			path: 'Legal',
			component: ()=>import("@/views/fat/Legal.vue"),
			meta:{
				title:"主体信息",
				requiresAuth:false
			},
		},
		{
			path: 'LegalEdit',
			component: ()=>import("@/views/fat/LegalEdit.vue"),
			meta:{
				title:"修改主体信息",
				requiresAuth:false
			},
		},
		{
			path: 'PaymentEdit',
			component: ()=>import("@/views/fat/PaymentEdit.vue"),
			meta:{
				title:"修改收款信息",
				requiresAuth:false
			},
		},
		{
			path: 'Tag',
			component: ()=>import("@/views/fat/Tag.vue"),
			meta:{
				title:"商品标签",
				requiresAuth:false
			},
		},
		{
			path: 'Shop',
			component: ()=>import("@/views/fat/Shop.vue"),
			meta:{
				title:"商品信息",
				requiresAuth:false
			},
		},
		{
			path: 'Validity',
			component: ()=>import("@/views/fat/Validity.vue"),
			meta:{
				title:"时效管理",
				requiresAuth:false
			},
		},
		// hitOrder
		{
			path: 'hitOrder',
			component: ()=>import("@/views/fat/hitOrder.vue"),
			meta:{
				title:"爆品订单",
				requiresAuth:false
			},
		},

		{
			path: 'ShopAdd/:good_id',
			component: ()=>import("@/views/fat/ShopAdd.vue"),
			meta:{
				title:"商品修改",
				requiresAuth:false
			},
		},
		{
			path: 'OrderDkzx',
			component: ()=>import("@/views/fat/OrderDkzx.vue"),
			meta:{
				title:"订单信息",
				requiresAuth:false
			},
		},
		{
			path: 'OrderDkzxC',
			component: ()=>import("@/views/fat/OrderDkzxC.vue"),
			meta:{
				title:"订单信息",
				requiresAuth:false
			},
		},
		{
			path: 'DeliveryOrder',
			component: ()=>import("@/views/fat/DeliveryOrder.vue"),
			meta:{
				title:"配送到店",
				requiresAuth:false
			},
		},
		{
			path: 'DeliveryOrderC',
			component: ()=>import("@/views/fat/DeliveryOrderC.vue"),
			meta:{
				title:"配送到店",
				requiresAuth:false
			},
		},
		{
			path: 'ToWarehouse',
			component: ()=>import("@/views/fat/ToWarehouse.vue"),
			meta:{
				title:"配送到仓",
				requiresAuth:false
			},
		},
		{
			path: 'Dropshipping',
			component: ()=>import("@/views/fat/Dropshipping.vue"),
			meta:{
				title:"一件代发",
				requiresAuth:false
			},
		},
		{
			path: 'Role',
			component: ()=>import("@/views/fat/Role.vue"),
			meta:{
				title:"角色管理",
				requiresAuth:false
			},
		},
		{
			path: 'User',
			component: ()=>import("@/views/fat/User.vue"),
			meta:{
				title:"员工管理",
				requiresAuth:false
			},
		},
		{
			path: 'Server',
			component: ()=>import("@/views/fat/Server.vue"),
			meta:{
				title:"服务信息",
				requiresAuth:false
			},
		},
		{
			path: 'SendAddr',
			component: ()=>import("@/views/fat/SendAddr.vue"),
			meta:{
				title:"地址管理",
				requiresAuth:false
			},
		},
		{
			path: 'OrderSaleLate',
			component: ()=>import("@/views/fat/OrderSaleLate.vue"),
			meta:{
				title:"售后订单",
				requiresAuth:false
			},
		},
		{
			path: 'OrderSaleLateC',
			component: ()=>import("@/views/fat/OrderSaleLateC.vue"),
			meta:{
				title:"售后订单",
				requiresAuth:false
			},
		},
		{
			path: 'dayReport',
			component: ()=>import("@/views/fat/dayReport.vue"),
			meta:{
				title:"订单日报表",
				requiresAuth:false
			},
		},
		{
			path: 'Driver',
			component: ()=>import("@/views/fat/Driver.vue"),
			meta:{
				title:"司机管理",
				requiresAuth:false
			},
		},
		{
			path: 'ShopReport',
			component: ()=>import("@/views/fat/ShopReport.vue"),
			meta:{
				title:"商品日报表",
				requiresAuth:false
			},
		},
		{
			path: 'Region',
			component: ()=>import("@/views/fat/Region.vue"),
			meta:{
				title:"地区管理",
				requiresAuth:false
			},
		},
		{
			path: 'Base',
			component: ()=>import("@/views/fat/Base.vue"),
			meta:{
				title:"配送管理",
				requiresAuth:false
			},
		},
		{
			path: 'ServerInfo/:service_id',
			component: ()=>import("@/views/fat/ServerInfo.vue"),
			meta:{
				title:"",
				requiresAuth:false
			},
		},
		{
			path: 'PriceAju',
			component: ()=>import("@/views/fat/PriceAju.vue"),
			meta:{
				title:"调价单",
				requiresAuth:false
			},
		},
		{
			path: 'PriceAjuAdd/:price_no',
			component: ()=>import("@/views/fat/PriceAjuAdd.vue"),
			meta:{
				title:"编辑调价单",
				requiresAuth:false
			},
		},
		{
			path: 'Invoice',
			component: ()=>import("@/views/fat/Invoice.vue"),
			meta:{
				title:"发货单管理",
				requiresAuth:false
			},
		},

	]
}

export default fat